import * as core from '../../../../../../../core'

import { query } from './revenue-metrics-report-card.query'

export const RESOURCE = {
  payload: {
    alias: 'revenue.metrics.report.card',
    description: 'Report card showing revenue metrics',
    name: 'Revenue Metrics Report Card',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
